import React, { useEffect, useState } from 'react';
const buyers = [{
  n: 'Emily R.',
  c: 'New York'
}, {
  n: 'James M.',
  c: 'Los Angeles'
}, {
  n: 'Ryan G.',
  c: 'Chicago'
}, {
  n: 'Sarah T.',
  c: 'Houston'
}, {
  n: 'Jason L.',
  c: 'Phoenix'
}, {
  n: 'Matt S.',
  c: 'San Diego'
}, {
  n: 'Ashley P.',
  c: 'Miami'
}, {
  n: 'David C.',
  c: 'Dallas'
}, {
  n: 'Jessica V.',
  c: 'Denver'
}, {
  n: 'Chris B.',
  c: 'Austin'
}, {
  n: 'Lauren D.',
  c: 'Nashville'
}, {
  n: 'Brian J.',
  c: 'Seattle'
}, {
  n: 'Nicole F.',
  c: 'Portland'
}, {
  n: 'Robert K.',
  c: 'Atlanta'
}, {
  n: 'Amanda M.',
  c: 'Charlotte'
}, {
  n: 'Kevin S.',
  c: 'San Francisco'
}, {
  n: 'Rachel H.',
  c: 'Boston'
}, {
  n: 'Tyler R.',
  c: 'Tampa'
}, {
  n: 'Monica P.',
  c: 'Las Vegas'
}, {
  n: 'Brandon Z.',
  c: 'Orlando'
}, {
  n: 'Megan N.',
  c: 'Minneapolis'
}];
export function SalesNotification() {
  const [visible, setVisible] = useState(false);
  const [buyer, setBuyer] = useState(buyers[0]);
  useEffect(() => {
    const showNotification = () => {
      const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
      setBuyer(randomBuyer);
      setVisible(true);
      setTimeout(() => setVisible(false), 5000);
    };
    // First notification after 5 seconds
    const initialTimeout = setTimeout(showNotification, 5000);
    // Then every 30 seconds
    const interval = setInterval(showNotification, 30000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <div role="status" aria-live="polite" className={`fixed bottom-4 left-4 right-4 sm:right-auto sm:left-5 sm:bottom-5 z-[10000] bg-dark/95 border border-gold/30 px-4 py-3 sm:px-5 sm:py-4 rounded-lg shadow-[0_10px_30px_rgba(0,0,0,0.5)] max-w-[340px] sm:max-w-none transition-all duration-500 ease-out transform ${visible ? 'translate-y-0 opacity-100' : 'translate-y-[150px] opacity-0 pointer-events-none'}`} data-id="element-105">
      <div className="flex items-center gap-3" data-id="element-106">
        <span className="text-xl" aria-hidden="true" data-id="element-107">
          💰
        </span>
        <div className="text-[11px] leading-[1.4]" data-id="element-108">
          <span className="font-extrabold text-gold" data-id="element-109">{buyer.n}</span>
          <span className="text-white" data-id="element-110"> from </span>
          <span className="text-white" data-id="element-111">{buyer.c}</span>
          <br data-id="element-112" />
          <span className="text-white/75 text-[10px] uppercase tracking-[1px]" data-id="element-113">
            Just activated The 888 Code
          </span>
        </div>
      </div>
    </div>;
}